import agencyDashboardAPI from '@/utils/api/agencyDashboard';
import {
  genericError,
  invitationDeleteSuccess,
  emailError,
  inviteSuccess,
} from '@/utils/alerts.service';
import router from '@/router/dashboard.js';

export const managePartnersInvitation = {
  namespaced: true,
  state: {
    invitation: {},
  },
  getters: {
    invitation(state) {
      return state.invitation;
    },
  },
  mutations: {
    setInvitation(state, data) {
      state.invitation = data;
    },
  },
  actions: {
    async getInvitation({ dispatch, commit }, id) {
      return agencyDashboardAPI
        .getInvitation(id)
        .then(data => {
          commit('setInvitation', data);
        })
        .catch(() => {
          dispatch('showUserMessage', { ...genericError }, { root: true });
        });
    },

    async resendPartnersInvite({ dispatch }, email) {
      const data = {
        email: email,
      };

      return agencyDashboardAPI
        .resendPartnersInvite(data)
        .then(() => {
          dispatch('showUserMessage', { ...inviteSuccess }, { root: true });
          router.push('/agency/our-directory/manage-partners');
        })
        .catch(() => {
          dispatch('showUserMessage', { ...emailError }, { root: true });
        });
    },

    async deleteInvitation({ dispatch }, id) {
      return agencyDashboardAPI
        .deleteInvitation(id)
        .then(() => {
          dispatch(
            'showUserMessage',
            { ...invitationDeleteSuccess },
            { root: true }
          );
          router.push('/agency/our-directory/manage-partners');
        })
        .catch(() => {
          dispatch('showUserMessage', { ...genericError }, { root: true });
        });
    },
  },
};
